import api from "../apiapp";
import apisign from "../api";


const statementService = {
    getStatements: async function () {
        const response = await api.request({
          url: "statement-signatures?include=swornStatement,sentBy,statementSignatureStatus&sort=-id&page[size]=30",
          method: "GET",
        })

        return response.data
    },
    getStatementsSearchPagination: async function (purl) {
      const response = await api.request({
        url: purl,
        method: "GET",
      })
      
      return response.data
    },
    getStatementSearch: async function (model) {
      var filters = '';
      if(model.name !== ""){ filters += '&filter[name]='+model.name; }
      if(model.noti !== ""){ filters += '&filter[swornStatement]='+model.noti; }
      if(model.status !== ""){ filters += '&filter[status]='+model.status; }
      if(model.date !== "" && model.date !== null){ filters += '&filter[signedAt]='+model.date; }
        
      const response = await api.request({
        url: "/statement-signatures?include=swornStatement,sentBy,statementSignatureStatus&sort=-id&page[size]=30"+filters,
        method: "GET",
      })
    
      return response.data
    },
    getStatementsLists: async function () {
      const response = await api.request({
        url: '/sworn-statements?page[size]=200',
        method: "GET",
      })
      
      return response.data
    },
    sendStatements: async function (model) {
      const response = await api.request({
        url: '/statement-signatures',
        method: "POST",
        data: model
      })
      
      return response.data
    },
    getStatementByToken: async function (token) {
      const response = await apisign.request({
        url: '/statement-signatures/show-by-token/'+token,
        method: "GET",
      })
      
      return response.data
    },
    setStatementSignature: async function (token) {
      const response = await apisign.request({
        url: '/statement-signatures/sign/',
        method: "POST",
        data: {
          token: token,
          via: "web"
        }
      })
      
      return response.data
    },
    getStatementActiveList: async function (param) {
      const response = await api.request({
        url: '/sworn-statements?page[size]=200&filter[status]='+param,
        method: "GET",
      })
      
      return response.data
    },

}
  
export default statementService;